export default __webpack_public_path__ + "static/media/026-desert.ebe7fb83.svg";